module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/main-visual-116675d4d075d78fc8e0b12dbb6fa105.webp";